<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%"></div>

    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
        <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
          <div>Select Near Dup Text Groups</div>
        </div>
      </mat-toolbar>

      <mat-card appearance="outlined" style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
        <div style="overflow-y: auto; flex: 1 1 1px; box-sizing: border-box;">
          <mat-card-content>
            <div *ngIf="!this.refreshing && !(nearDupTextGroupings.length > 0 && totalNearDupTextGroups > 0)">
              There is no near dup text group for current case.
            </div>
            <mat-nav-list *ngIf="!this.refreshing && nearDupTextGroupings.length > 0 && totalNearDupTextGroups > 0">
              @for(textGroup of nearDupTextGroupings; track textGroup) {
                <mat-list-item>
                  <a matListItemTitle class="nearDupGroupBrowseLink lex-theme-font--classic" [routerLink]="['/review/browse']" [queryParams]="{ TextGroupId: textGroup.textGroupId, ShowTextGroups: true }" 
                      style="box-sizing: border-box; display: flex; height: 100%; place-content: center space-between; align-items: center;">
                      {{textGroup.groupTitle}}
                  </a>
                  <div matListItemMeta class="lex-theme-font--classic" style="font-size: 16px;">
                      {{textGroup.docCount}}
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
              }
             </mat-nav-list>
          </mat-card-content>
        </div>

        <mat-card-actions align="right" *ngIf="!this.refreshing &&  nearDupTextGroupings.length > 0 && totalNearDupTextGroups > 0">
          <mat-paginator class="density-neg-5"
                         [length]="totalNearDupTextGroups"
                         [pageIndex]="pageIndex"
                         [pageSize]="pageSize"
                         [pageSizeOptions]="pageSizeOptions"
                         (page)="pageEvent = getPage($event)">
          </mat-paginator>
        </mat-card-actions>
      </mat-card>

    </div>

    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%"></div>
  </div>
</div>
